import { render, staticRenderFns } from "./RefundApply.vue?vue&type=template&id=5a80f96d&scoped=true&"
import script from "./RefundApply.vue?vue&type=script&lang=js&"
export * from "./RefundApply.vue?vue&type=script&lang=js&"
import style0 from "./RefundApply.vue?vue&type=style&index=0&id=5a80f96d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80f96d",
  null
  
)

export default component.exports